import { render, staticRenderFns } from "./BotPart.vue?vue&type=template&id=8e63267e&scoped=true"
import script from "./BotPart.vue?vue&type=script&lang=js"
export * from "./BotPart.vue?vue&type=script&lang=js"
import style0 from "./BotPart.vue?vue&type=style&index=0&id=8e63267e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e63267e",
  null
  
)

export default component.exports